class LanguageOption {
  constructor(name, code) {
    this.name = name;
    this.code = code;
  }
}

class LanguageOptions {
  initDefaultOptions() {
    this.options = [
      new LanguageOption("English", "en-GB"),
      new LanguageOption("हिन्दी", "hi"),
      new LanguageOption("मराठी", "mr"),
    ];
  }

  constructor(options) {
    options ? (this.options = options) : this.initDefaultOptions();
  }
}

export { LanguageOption, LanguageOptions };
